export const tableColumn = [
  {
    text:'用券用户手机号',
    value:'thirdBuyer'
  },
  {
    text:'领券时间',
    value:'createTimeStr'
  },
  {
    text:'天猫券名称',
    value:'couponName'
  },
  {
    text:'团购券面值',
    value:'couponPriceBd'
  },
  {
    text:'核销券码',
    value:'code'
  },
  {
    text:'天猫券订单号',
    value:'thirdOrderId'
  },
  {
    text:'应收金额',
    value:'payAmountBd'
  },
  {
    text:'券使用状态',
    value:'statusStr'
  },
  {
    text:'券退款状态',
    value:'isRefundStr'
  },
  {
    text:'用券影票订单号',
    value:'orderId'
  },
  {
    text:'市场价',
    value:'initPriceBd'
  },
  {
    text:'券后支付价',
    value:'couponPayPriceBd'
  },
  {
    text:'指导价',
    value:'guidePriceBd'
  },
  {
    text:'用券时间',
    value:'useTimeStr'
  },
]



// WEBPACK FOOTER //
// ./src/views/pc/miniProgram/couponTaoBaoNew/component/enum.js